import React from 'react';

/* Profile → Overview tab: welcome line + labelled info rows (border-bottom). */
export default function Overview({ user }) {
  const Row = ({ label, value, green, last }) => (
    <div className={last ? 'row' : 'row border-bottom'}>
      <div className="col-lg-3 col-4 label">{label} :</div>
      <div className="col-lg-9 col-8">{green ? <span className="green">{value}</span> : value}</div>
    </div>
  );
  return (
    <div className="profile-overview">
      <h5 className="card-title">Welcome to Reddy Anna Book, <b>{user.id}</b></h5>
      <Row label="User Id" value={user.id} />
      <Row label="Available Chips" value={user.availableChips} />
      <Row label="exposure" value={user.exposureChips} />
      <Row label="Total Chips" value={user.totalChips} />
      <Row label="Profit/Loss" value={user.profitLoss} green last />
    </div>
  );
}
